import { dramas, type Drama } from "@/mocks/dramas";

export const dramaMap: Record<string, Drama> = dramas.reduce(
  (acc, item) => {
    acc[item.id] = item;
    return acc;
  },
  {} as Record<string, Drama>
);

export function getDramaById(id: string): Drama | undefined {
  return dramaMap[id];
}

export function getRelatedDramas(item: Drama): Drama[] {
  return item.recommendIds
    .map((rid) => dramaMap[rid])
    .filter((d): d is Drama => Boolean(d));
}

export function formatDate(date: string): string {
  const parts = date.split("-");
  if (parts.length !== 3) return date;
  return `${parts[0]}年${Number(parts[1])}月${Number(parts[2])}日`;
}